import { useTabsStore } from '@shared/stores/tabs.store';

export function chatIdFromTabPath(path: string | undefined): string | null {
  const query = path?.split('?')[1];
  if (!query) return null;
  return new URLSearchParams(query).get('c');
}

export function isChatOpenInOtherTab(chatId: string): boolean {
  const { tabs, activeTabId } = useTabsStore.getState();
  return tabs.some((t) => t.id !== activeTabId && chatIdFromTabPath(t.path) === chatId);
}
